import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomChip = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1,
		transform: "translate(0.251,-0.204)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 8.25,
				cy: 8.704,
				r: 7.11
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 8.249,
				cy: 8.703,
				r: 4.175
			}),
			/* @__PURE__ */ _jsx("path", { d: "M8.249 4.529V1.594m0 14.219v-2.935m-3.614-2.087-2.542 1.467m12.314-7.109-2.542 1.467m0 4.175 2.542 1.467M2.093 5.149l2.542 1.467" })
		]
	})
});
export { SvgCustomChip as ReactComponent };
